module.exports = __webpack_public_path__ + "static/map-bg.4185171b.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/map-bg.gif
// module id = 472
// module chunks = 168707334958949